<template>
  <div>
    <validation-provider
      :name="question.label"
      v-if="hasAnswer(answer) && isTextAreType(question) && isRequired(question)"
      rules="required"
      mode="lazy"
      v-slot="{ errors }"
    >
      <h4 class="question_text-area__title required">{{ question.question }} *</h4>
      <p class="question_text-area__description">{{ question.attributes.description }}</p>
      <vs-textarea
        class="question_text-area__input no-icon-border"
        rows="3"
        v-model="answer.value"
        :style="{ borderColor: errors.length > 0 ? 'red' : 'rgba(0,0,0,0.2)' }"
      />
      <span v-if="errors.length > 0" class="text-danger">
        Campo de resposta obrigatória
      </span>
    </validation-provider>
    <validation-provider
      :name="question.label"
      v-if="hasAnswer(answer) && isTextAreType(question) && !isRequired(question)"
      v-slot="{ errors }"
      mode="lazy"
    >
        <h4 class="question_text-area__title">{{ question.question }}</h4>
        <p class="question_text-area__description">{{ question.attributes.description }}</p>
        <vs-textarea
          class="question_text-area__input no-icon-border"
          rows="3"
          v-model="answer.value"
          :style="{ borderColor: errors.length > 0 ? 'red' : 'rgba(0,0,0,0.2)' }"
        />
        <div v-if="{errors}"></div>
    </validation-provider>
  </div>
</template>

<style lang="scss" scoped>
.question_text-area__title {
  font-size: 16px;
  font-weight: 400;
  line-height: 18.75px;
  color: #4F4F4F;
  margin: 10px 0;
}

.question_text-area__description {
  font-size: 14px;
  font-weight: 400;
  line-height: 16.41px;
  color: #4F4F4F;
  margin-bottom: 10px;
}
.question_text-area__input {
  width: 100%;
  margin-bottom: 5px;
  color: #000;
}
.required {
  color: #333333;
}
</style>

<script>
import { ValidationProvider } from "vee-validate";

export default {
  components: { ValidationProvider },
  name: "question-text-area",
  props: {
    answer: {
      type: Object,
      required: true
    },
    question: {
      type: Object,
      required: true
    }
  },
  model: {
    prop: "model"
  },
  methods: {
    hasAnswer: answer => Object.keys(answer).length > 0,
    isTextAreType: question => question.type === "textarea",
    isRequired: question => question.required
  },
  mounted() {
    this.model = this.answer[this.question._id].value;
  }
};
</script>
